import { cn } from '@/lib/utils';

/**
 * Logo BCL Telecom & Énergie — PNG officiel récupéré du source Loveable
 * (public/lovable-uploads/232e74ed-4227-4cf1-9ef2-da0b560d7d06.png).
 * Reproduit le composant Logo.tsx du repo fiberfriend-portal à l'identique.
 */
export function BrandLogo({
  className,
  size = 'md',
}: {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  const h = size === 'lg' ? 'h-12' : size === 'sm' ? 'h-9' : 'h-10';
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src="/lovable-uploads/232e74ed-4227-4cf1-9ef2-da0b560d7d06.png"
        alt="BCL Telecom & Énergie"
        className={cn(h, 'w-auto')}
      />
    </div>
  );
}
